export var euiSize = 16
export var euiSizeXs = 4
export var euiSizeS = 8
export var euiSizeM = 12
export var euiSizeL = 24
export var euiSizeXl = 32
export var euiSizeXxl = 40
export var euiButtonMinWidth = 112
export var euiScrollBar = 16
export var euiScrollBarCorner = 6
export default {"euiSize":16,"euiSizeXS":4,"euiSizeS":8,"euiSizeM":12,"euiSizeL":24,"euiSizeXL":32,"euiSizeXXL":40,"euiButtonMinWidth":112,"euiScrollBar":16,"euiScrollBarCorner":6}
